const PermissionToggleConfig = [{ span: 12, height: "190px", classes: "marginTop-24" }]
export default PermissionToggleConfig
